import React from 'react';
import classNames from 'classnames';

const Spinner = ({ color = 'black', inline = false, className }) => (
  <div
    aria-hidden="true"
    className={classNames(
      'spinner',
      `spinner--${color}`,
      { 'spinner--inline': inline },
      className
    )}
  >
    <div className="spinner__element" />
  </div>
);

export default Spinner;
